import { render, staticRenderFns } from "./SystemMessages.vue?vue&type=template&id=1bbcc0a7&scoped=true&"
import script from "./SystemMessages.vue?vue&type=script&lang=js&"
export * from "./SystemMessages.vue?vue&type=script&lang=js&"
import style0 from "./SystemMessages.vue?vue&type=style&index=0&id=1bbcc0a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbcc0a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bbcc0a7')) {
      api.createRecord('1bbcc0a7', component.options)
    } else {
      api.reload('1bbcc0a7', component.options)
    }
    module.hot.accept("./SystemMessages.vue?vue&type=template&id=1bbcc0a7&scoped=true&", function () {
      api.rerender('1bbcc0a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/SystemMessages.vue"
export default component.exports